import { observer } from 'mobx-react';
import React from 'react';

import { DbKey } from '../../../../adl-gen/common/db';
import { WorkRole } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { WorkRoleListEntry } from '../../../../adl-gen/totalinteraction/futurefit/frontend';
import { WorkRoleReferenceData } from '../../../../adl-gen/totalinteraction/futurefit/requests';
import { Loader } from '../../../../loader/loader';
import { Route } from '../../../../routing/app-routes';
import { WorkRoleStore } from '../../../stores';
import { FormMode } from '../../common/form';
import { AdminPageLayoutFn } from '../../common/page-layout/admin-page-layout';
import { WorkRoleForm } from '../../components/forms/workrole-form/workrole-form';
import { WorkRoleDetailsView } from '../../components/detail-views/workrole-details-view';

interface WorkRoleDetailScreenProps {
  pageLayout: AdminPageLayoutFn;
  navigateTo(route: Route): void;
  mode?: FormMode;

  // data: MaybeLoading<RoleBuilderData>
  selectedRole?: WorkRoleListEntry;
  store: WorkRoleStore;

  onCancel?(): Promise<void>;
  onUpdate?(workroleId: DbKey<WorkRole>): Promise<void>;
  onCloneWorkRole?(workroleId: DbKey<WorkRole>): Promise<void>;
}

@observer
export class WorkRoleDetailScreen extends React.Component<WorkRoleDetailScreenProps> {
  onRoleBuilderUpdate = (id: DbKey<WorkRole>) => {
    this.props.navigateTo({
      route: 'admin',
      page: 'role-builder',
      view: 'update',
      appClientId: this.props.store.clientId,
      id
    });
  };

  onGenerateQuiz = (workRoleId: DbKey<WorkRole>) => {
    this.props.navigateTo({
      route: 'admin',
      page: 'quiz-admin',
      view: 'new',
      appClientId: this.props.store.clientId,
      workRoleId
    });
  };

  renderWorkRoleDetails = observer((data: WorkRoleReferenceData) => {
    const { onCloneWorkRole, onUpdate, selectedRole, store } = this.props;
    const roleBuilderData =
      store.loadingRoleBuilderData.kind === 'value' ? store.loadingRoleBuilderData.value : undefined;

    if (data && roleBuilderData && onCloneWorkRole && onUpdate && selectedRole) {
      return (
        <WorkRoleDetailsView
          workrole={selectedRole}
          roleData={data}
          roleBuilderData={roleBuilderData}
          onUpdate={onUpdate}
          onRoleBuilderUpdate={this.onRoleBuilderUpdate}
          onGenerateQuiz={this.onGenerateQuiz}
          onCloneWorkRole={onCloneWorkRole}
          // TODO: Nav to other screen - this is just a shortcut
          onUpdateQuiz={store.updateQuiz}
          applicationRole={store.isSuperUser ? 'super' : 'client-admin'}
        />
      );
    } else {
      return null;
    }
  });

  renderCreateWorkRoleForm = observer((data: WorkRoleReferenceData) => {
    const { mode, onCancel, store } = this.props;

    if (onCancel) {
      return <WorkRoleForm store={store} roleData={data} mode={mode} onCancel={onCancel} />;
    } else {
      return null;
    }
  });

  renderUpdateWorkRoleForm = observer((data: WorkRoleReferenceData) => {
    const { mode, onCancel, selectedRole, store } = this.props;

    if (onCancel && selectedRole) {
      return <WorkRoleForm item={selectedRole} roleData={data} store={store} mode={mode} onCancel={onCancel} />;
    } else {
      return null;
    }
  });

  WorkRoleDetailsLoader = () => {
    const { selectedRole: role, store, mode } = this.props;
    if (role) {
      if (mode === 'update' || mode === 'delete' || mode === 'clone') {
        return <Loader state={store.loadingData} LoadedComponent={this.renderUpdateWorkRoleForm} />;
      } else {
        /// View
        return <Loader state={store.loadingData} LoadedComponent={this.renderWorkRoleDetails} />;
      }
    } else {
      /// Create - mode doesn't matter
      return <Loader state={store.loadingData} LoadedComponent={this.renderCreateWorkRoleForm} />;
    }
  };

  render() {
    const { selectedRole } = this.props;
    const roleNameEn = selectedRole ? `${selectedRole.name.value.en} ` : '';
    // TODO: This is not the correct place to get the client name from - should not show
    // TODO: for superuser but will do so here
    const clientName = selectedRole && selectedRole.appClient ? `${selectedRole.appClient.name} ` : '';
    return (
      <this.props.pageLayout title={`${clientName}Administration - ${roleNameEn}Role`}>
        <this.WorkRoleDetailsLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/workrole-detail-screen/workrole-detail-screen.tsx